
const ValueProposition = () => {
  const keyPoints = [
    {
      title: 'Precision-first AI deployment',
      description: 'Targeted solutions that address specific operational pain points',
      icon: 'ri-focus-3-line'
    },
    {
      title: 'Systems engineered for real operations',
      description: 'Built to integrate seamlessly with your existing workflows',
      icon: 'ri-settings-4-line'
    },
    {
      title: 'Measurable outcomes, not experimentation',
      description: 'Every deployment is tracked and optimized for results',
      icon: 'ri-bar-chart-box-line'
    },
  ];

  return (
    <section className="bg-zinc-950 py-32 relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-emerald-500/40 to-transparent"></div>
      
      {/* X Pattern Background */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="xPatternValue" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse">
              <line x1="0" y1="0" x2="60" y2="60" stroke="#10B981" strokeWidth="0.5" />
              <line x1="60" y1="0" x2="0" y2="60" stroke="#10B981" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#xPatternValue)" />
        </svg>
      </div>

      {/* Background Visual */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1/3 h-4/5 opacity-20">
        <img
          src="https://public.readdy.ai/ai/img_res/c90b91dff73ea7c134d5a27ff99f670c.jpg"
          alt="Precision Engineering"
          className="w-full h-full object-contain object-center"
        />
      </div>

      {/* Floating X Elements */}
      <div className="absolute top-20 left-10 text-emerald-500/5 text-[120px] font-bold">✕</div>
      <div className="absolute bottom-20 left-1/4 text-teal-500/5 text-[80px] font-bold rotate-45">✕</div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <div className="mb-6">
              <span className="text-emerald-400 text-xs font-semibold uppercase tracking-widest">
                THE CRUXONAI DIFFERENCE
              </span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight mb-8">
              AI Built for the Point of Impact
            </h2>
            <p className="text-lg text-gray-300 leading-relaxed">
              Most businesses don't need more tools — they need intelligence applied at the right moment. CruxOnAI identifies operational friction, revenue leakage, and breakdowns in client experience, then installs AI systems exactly where they create measurable leverage.
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="space-y-6">
              {keyPoints.map((point, index) => (
                <div
                  key={index}
                  className="group bg-zinc-900/80 backdrop-blur-sm border border-zinc-800 hover:border-emerald-500/30 p-8 rounded-xl hover:bg-zinc-800/80 transition-all duration-300"
                >
                  <div className="flex items-start gap-6">
                    <div className="w-14 h-14 flex items-center justify-center bg-emerald-500/10 rounded-xl group-hover:bg-emerald-500/20 transition-colors">
                      <i className={`${point.icon} text-emerald-400 text-2xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-white text-xl font-semibold mb-2">{point.title}</h3>
                      <p className="text-gray-400 text-sm">{point.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
